<template>
  <div class="background">
    <div class="main-body">
      <h1>注册</h1>
      <Divider />
      <Form
        style="margin-top: 12px;"
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="名字" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字" />
        </FormItem>
        <FormItem label="手机号" prop="mobile">
          <Input v-model="formItem.mobile" placeholder="输入手机号" />
        </FormItem>
        <FormItem label="密码" prop="password">
          <Input type="password" v-model="formItem.password" placeholder="输入密码" />
        </FormItem>
        <FormItem label="代码" prop="registerCode">
          <Input v-model="formItem.registerCode" placeholder="输入代码" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">下一步</Button>
        </FormItem>
      </Form>
      <router-link to="/login" class="signup-button">
        <a>已有账号？点击登陆</a>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "signup",
  data() {
    return {
      currentStep: 0,
      formItem: {
        name: null,
        mobile: null,
        password: null,
      },
      ruleValidate: {
        name: [{ required: true, message: "请填写名字", trigger: "blur" }],
        mobile: [{ required: true, message: "请填写手机", trigger: "blur" }],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          {
            type: "string",
            min: 8,
            message: "密码必须大于8位数",
            trigger: "blur",
          },
        ],
        registerCode: [
          { required: true, message: "请填写手机", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions({
      signupByRegisterCode: "auth/signupByRegisterCodeAction",
    }),
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            const user = await this.signupByRegisterCode(this.formItem);
            if (user) {
              this.$Message.success(`注册成功，请登录`);
              this.$router.push("/login");
            }
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("请将表格填写完整!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.background
  width 100%
  height 100vh
  background-color #425384
  overflow hidden
  display flex
  justify-content center
  align-items center

.main-body
  width 500px
  background-color white
  border-radius 6px
  padding 24px
  margin-bottom 15px
</style>
